import { getFormattedPrice } from '.';
import { CurrencyISOCode, FormattedPriceCalculationResponse } from '..';

export default function (
  currencyISOCode: CurrencyISOCode
): FormattedPriceCalculationResponse {
  const zeroPrice = getFormattedPrice(currencyISOCode, 0);

  return {
    totalPrice: 0,
    avgPerUnitPrice: 0,

    formattedTotalPrice: zeroPrice,
    formattedAvgPerUnitPrice: zeroPrice,

    hasFlatRateFirstTier: true,
    hasExceededMaxTier: false,

    breakdown: [
      {
        unitsInTier: 0,
        unitsAvailableInTier: 0,

        unitLimitLower: 0,
        unitLimitUpper: 0,

        totalPriceForTier: 0,
        avgPerUnitPriceForTier: 0
      }
    ],
    formattedBreakdown: [
      {
        formattedUnitsInTier: '0',
        formattedUnitsAvailableInTier: '0',

        formattedUnitLimitLower: '0',
        formattedUnitLimitUpper: '0',

        formattedTotalPriceForTier: zeroPrice,
        formattedAvgPerUnitPriceForTier: zeroPrice
      }
    ]
  };
}
